import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c4852f9c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c4852f9c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4852f9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4852f9c')) {
      api.createRecord('c4852f9c', component.options)
    } else {
      api.reload('c4852f9c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c4852f9c&scoped=true", function () {
      api.rerender('c4852f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/questionnaire/homeManage/questionnaireRecord/index.vue"
export default component.exports